import { motion, useScroll, useSpring } from "framer-motion";

export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 30, restDelta: 0.001 });

  return (
    <motion.div
      data-testid="scroll-progress"
      className="fixed top-0 left-0 right-0 z-[70] h-[2px] origin-left"
      style={{ scaleX, background: "linear-gradient(90deg, #C9A84C, #E0C375)" }}
    />
  );
}
